import React from 'react';
import { NavLink as RouterLink } from 'react-router';

import styled from '@emotion/styled';

// import { useAppSelector } from '../../redux/store';
import GradientText from '../Cards/GradientText';

interface AuthLayoutProps {
  children?: any;
  label?: string;
  linkTitle?: string;
  linkPath?: string;
  forgotPassword?: boolean;
  headerImgSrc?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  label,
  linkTitle,
  linkPath,
  headerImgSrc,
}) => {
  // const signUpData = useAppSelector((state) => state.signUpData);

  return (
    <AuthLayoutContainer>
      <FormArea>
        <FormAreaHeader>
          <CompanyLogo
            onClick={() =>
              (window.location.href = 'https://logirate-web.rateduct.com')
            }
            src='/static/img/logirate-logo.png'
          />
          <LinkArea>
            <LinkSection>
              <LinkSectionLabel>{label}</LinkSectionLabel>{' '}
              <Link to={linkPath || '/'}>{linkTitle}</Link>{' '}
            </LinkSection>
          </LinkArea>
        </FormAreaHeader>
        <FormSection>
          {headerImgSrc && <FormSectionHeaderImg src={headerImgSrc} />}
          <FormBody>{children}</FormBody>
        </FormSection>
      </FormArea>

      <ImgArea>
        <BackDropText>
          <p>
            Rating System <br />
            Built for <GradientText>Businesses</GradientText>
          </p>
        </BackDropText>
      </ImgArea>

      <MobileLinkArea>
        <LinkSection>
          <MobileLinkSectionLabel>{label}</MobileLinkSectionLabel>{' '}
          <Link to={linkPath || '/'}>{linkTitle}</Link>{' '}
        </LinkSection>
      </MobileLinkArea>
    </AuthLayoutContainer>
  );
};

const MobileLinkArea = styled.div`
  display: none;
  justify-content: center;
  padding: 16px 20px 24px;

  @media (max-width: 884px) {
    display: flex;
    margin-bottom: 40px;
  }
`;

const AuthLayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.palette.brandBackdrop};
  padding: 20px;
  gap: 20px;

  @media (max-width: 884px) {
    padding: 0;
    flex-direction: column;
    min-height: 100vh;
    height: auto;
    overflow: auto;
    background-color: white;
  }
`;

const FormSectionHeaderImg = styled.img`
  width: 16rem;
  align-self: center;
`;

const FormBody = styled.div`
  @media (max-width: 884px) {
    width: 100%;
  }
`;

const FormAreaHeader = styled.div`
  padding: 50px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 884px) {
    padding: 24px 20px 0;
  }
`;

const CompanyLogo = styled.img`
  width: 7.86rem;
  cursor: pointer;

  @media (max-width: 884px) {
    display: none;
  }
`;

const LinkArea = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 884px) {
    gap: 0px;
    display: none;
  }
`;

const LinkSection = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.logirateBlack};
  font-weight: 400;
`;

const LinkSectionLabel = styled.span`
  @media (max-width: 884px) {
    display: none;
  }
`;

const MobileLinkSectionLabel = styled.span``;

const Link = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.blueColor};
  font-weight: 800;
`;

const FormArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  width: 100%;
  flex-basis: 50%;
  background-color: ${({ theme }) => theme.palette.bgWhiteColor};
  border-radius: 24px;
  /* border: 1px solid red; */
  overflow: auto;
  padding-bottom: 36px;

  @media (max-width: 884px) {
    gap: 1.5rem;
    width: 100%;
    flex: 1;
    flex-basis: 100%;
    min-height: auto;
    height: auto;
    border-radius: 0;
    background-color: ${({ theme }) => theme.palette.bgWhiteColor};
    padding-bottom: 24px;
  }
`;

const FormSection = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  /* border: 1px solid blue; */
  height: fit-content;

  @media (max-width: 884px) {
    margin: 0;
    flex: 1;
    width: 100%;
    justify-content: center;
    padding: 0 20px 24px;
  }
`;

const ImgArea = styled.div`
  display: flex;
  flex-basis: 50%;

  @media (max-width: 884px) {
    display: none;
  }
`;

const BackDropText = styled.div`
  width: 100%;

  background-image: url(/static/svg/signup-backdrop.svg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 56px;
  font-weight: 600;
  line-height: 80px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;
